/**
 * Catalogue route paths as constants, so no client ever writes a URL as a
 * string. Same rule as `../iam/routes.ts`: a typo in a path is otherwise a 404
 * discovered at runtime, and here it does not compile.
 */
export const CATALOG_ROUTES = {
    /** The paged, filtered exercise list — the list screen's only data source. */
    exercises: "/catalog/exercises",
    /**
     * One exercise in full — the detail screen (`T49`).
     *
     * This is the SERVER'S pattern, with Hono's `:id` placeholder in it, and a
     * client must never fetch it verbatim. `exerciseDetailPath(id)` in
     * `exercise-detail.ts` is what builds a real path, encoding the id on the
     * way; a client that string-replaced `:id` itself would be a second encoder
     * to keep in agreement with the server's decoder.
     */
    exercise: "/catalog/exercises/:id",
    /**
     * "Dados errados?" — one report against one exercise (`D199`). `POST` only.
     * The server's pattern again: `exerciseReportsPath(id)` in
     * `exercise-report.ts` builds the real path.
     */
    exerciseReports: "/catalog/exercises/:id/reports",
    /** The filter vocabulary and its counts. Static for the life of a seed. */
    filters: "/catalog/filters",
    /** The whole catalogue for the device, once per locale (`D194`). */
    snapshot: "/catalog/snapshot",
};
//# sourceMappingURL=routes.js.map